// Vuex connections module actions

import { API } from "@/config";

import { FILL_LIST, FILL_LIST_COUNT, FILL_CALENDAR } from "./mutations-types";

export default {
  async getList({ commit }, data) {
    try {
      const params = {
        type: data.type
      };
      const response = (await API.get("/callPlanner/getList", { params })).data.data;
      commit(FILL_LIST, response);
    } catch (err) {
      console.log(err);
    }
  },
  async getListCount({ commit }) {
    try {
      const response = (await API.get("/callPlanner/getListCount")).data.data;
      commit(FILL_LIST_COUNT, response);
    } catch (err) {
      console.log(err);
    }
  },
  async updateLastCallAttempt(context, params) {
    try {
      const response = (await API.patch("/callPlanner/updateLastCallAttempt", params)).data.code;
      return response === 200 ? true : false;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async removeOrRestorePlannedCall(context, params) {
    try {
      const response = (await API.patch("/callPlanner/removeOrRestorePlannedCall", params)).data;
      return response;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async addRecordToPlanner(context, params) {
    try {
      const response = (await API.put("/callPlanner/addRecordToPlanner", params)).data.code;
      return response === 200 ? true : false;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getCalendarEventsList({ commit }, dates) {
    try {
      const params = {
        start_date: dates.startDate,
        end_date: dates.endDate
      };
      const response = (await API.get("/callPlanner/getCalendarEventsList", { params })).data.data;
      commit(FILL_CALENDAR, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  }
};
